// this.$store.state.notificacion
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import moment from "moment";

// NOTIFICACION
export const notificacion = {
  objeto: class {
    constructor() {
      return {
        id: "",
        idEmpresa: "",
        tipo: "", // ALERTA, RECORDATORIO Y INFORMATIVO
        prioridad: "", // ALTA (ALERTA), MEDIA (RECORDATORIOS) Y BAJA (INFORMATIVAS)
        titulo: "",
        contenido: "",
        url: "",
        modulo: "",
        esLeida: false,
        esVisible: true,
        idUsuario: {
          emisor: "",
          receptor: "",
        },
        registro: {
          filtro: moment().format("YYYY-MM-DD"),
          leida: serverTimestamp(),
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
        },
      };
    }
  },
  funciones: {
    async obtener(id) {
      const q = query(
        collection(db, "riskmann_notificaciones"),
        where("id", "==", id),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    },
    async marcarLeida(id) {
      await updateDoc(doc(db, "riskmann_notificaciones", id), {
        esLeida: true,
        "registro.actualizacion": serverTimestamp(),
        "registro.leida": serverTimestamp(),
      });
    },
  },
};
